<script>
  import { createEventDispatcher } from "svelte"
  export let cliente

  const dispatch = createEventDispatcher()

  const actualizarprobabilidad = () => {
    dispatch("update", {
      probabilidad: cliente.probabilidad,
    })
  }

  function getColor(prob) {
    const r = Math.round(220 + (40 - 220) * (prob / 100))
    const g = Math.round(53 + (167 - 53) * (prob / 100))
    const b = 69
    return `rgb(${r}, ${g}, ${b})`
  }

  $: thumbColor = getColor(cliente.probabilidad)
</script>

<div class="text-end">
  <label for="probabilidad" class="form-label mb-0">
    <span class="fg-secondary small"
      >Probabilidad de cierre: {cliente.probabilidad}%</span
    >
  </label>

  <div
    class="form-range"
    style="--bs-range-track-bg: #dee2e6; --bs-range-track-fill-bg: {thumbColor}; --bs-range-fill: {cliente.probabilidad / 100}; --bs-range-thumb-bg: {thumbColor}; --bs-range-thumb-active-bg: {thumbColor};"
  >
    <input
      class="form-range-input"
      type="range"
      id="probabilidad"
      min="0"
      max="100"
      bind:value={cliente.probabilidad}
      on:change={actualizarprobabilidad}
    />
  </div>
</div>
